<app-dialog-content>
  <app-table [value]="items">
    @for (col of columns; track col) {
      <ng-template
        [header]="col.header | translate"
        [appColumn]="col.field"
        let-item
      >
        {{ item[col.field] }}
      </ng-template>
    }
  </app-table>
</app-dialog-content>
<div class="dialog-footer">
  <app-progress-bar
    [hidden]="!qrGenerating"
    [progress]="qrProgress"
    class="qr-progressbar"
  ></app-progress-bar>
  <button
    (click)="exportQRCodes()"
    data-qa="user-list-generate-pin-export-qrcode-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'user.generated_pin_list.button.export_qr.label' | translate }}
  </button>
  <button
    (click)="exportCsv()"
    data-qa="user-list-generate-pin-export-csv-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'user.generated_pin_list.button.export_csv.label' | translate }}
  </button>
  <button
    (click)="close()"
    data-qa="user-list-generate-pin-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
</div>
